import React from "react";
import "./NewFooter.scss";
import { AllImages } from "../../Assets/Images/AllImages";

import user from "../../Common/JsonFiles/rohan.json";
const NewFooter = () => {
  return (
    <div className="new-footer-container">
      <div className="new-footer-txt">Living, learning, & leveling up...</div>
      <div className="new-footer-social-icons">
        <a
          href={user?.socialSites[0]?.url}
          style={{ textDecoration: "none", color: "white" }}
          target="_blank"
          rel="noreferrer"
        >
          <div className="single-img">
            <img src={AllImages.Gmail} alt="" />
          </div>
        </a>

        <a
          href={user?.socialSites[2]?.url}
          style={{ textDecoration: "none", color: "white" }}
          target="_blank"
          rel="noreferrer"
        >
          <div className="single-img">
            <img src={AllImages.Github} alt="" />
          </div>
        </a>

        <a
          href={user?.socialSites[1]?.url}
          style={{ textDecoration: "none", color: "white" }}
          target="_blank"
          rel="noreferrer"
        >
          <div className="single-img">
            <img src={AllImages.LinkedIn} alt="" />
          </div>
        </a>
      </div>

      <div className="created-by">Created by Rohan Nagar © 2023</div>
    </div>
  );
};

export default NewFooter;
